<!--
  description: "Show a SELECT via whicj the approtiate License can be selected"
  todo: "we have both Copyright and License in the Graph model; make this one, rethink naming"
  emits: "input event with selected value"
  todo: "remodel to use mapState"
-->
<template>
  <div>
    <ElRow>
      <ElCol :span="12">
        <select
          v-model="selected"
          @input="
            (event) => {
              $emit('input', event.target.value)
            }
          "
        >
          <option :key="o.uuid" :value="o.uuid" v-for="o in options">
            {{ o.code }} &mdash; {{ o.name }}
          </option>
        </select>
      </ElCol>
      <ElCol v-if="selected" :span="2">
        &nbsp;<ElButton
          type="danger"
          size="mini"
          circle
          icon="el-icon-delete"
          @click="remove"
        />
      </ElCol>
    </ElRow>
  </div>
</template>
<script>
export default {
  name: "HiCopyright",
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  mounted() {
    this.selected = this.value
  },

  computed: {
    options() {
      return this.$store.state.forms["licenses"]
    },
  },

  methods: {
    remove(item) {
      this.selected = ""
      this.$emit("remove", this.selected)
    },
  },

  data() {
    return {
      selected: "",
    }
  },
}
</script>
